import {
  richtext_default
} from "./chunk-KYXE3IBT.js";
import {
  show_run_label_default
} from "./chunk-UQ7EFRTL.js";
import {
  sanity_image_default
} from "./chunk-S7ZUUURB.js";
import {
  title_default
} from "./chunk-GI6JXUKL.js";
import {
  icon_default
} from "./chunk-KWWZIFUJ.js";
import {
  date_tile_default
} from "./chunk-XNHNVUOE.js";
import {
  link_default
} from "./chunk-6WQWOYMP.js";
import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/cards/hero/hero.tsx
import { isPast } from "date-fns";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CardHero = forwardRef(
  ({
    cta,
    className = "",
    dateTiles,
    description,
    endDate,
    id,
    image,
    imageMobile,
    labels = {
      bookNow: "Book Now",
      learnMore: "Learn More",
      flagNew: "New",
      nextShowTimes: "Next Show"
    },
    showId,
    startDate,
    targetPage,
    title
  }, ref) => {
    if (!title && !description) return null;
    const filteredTiles = dateTiles?.filter((tile) => {
      return !isPast(new Date(tile?.startDate || ""));
    });
    return /* @__PURE__ */ jsx(
      "article",
      {
        id: showId,
        ref,
        className: [
          `${className} theme-light bg-heritage-white-full`,
          "pl-6 pr-6 pt-6 pb-4 lg:pl-16 lg:pr-16 lg:pt-8 lg:pb-10",
          "rounded-t-2xl shadow-[0_-0.625rem_1rem_rgba(0,0,0,0.08)]",
          "flex flex-col justify-between items-start"
        ].join(" "),
        children: /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-x-6 items-start auto-rows-max h-full w-full", children: [
          /* @__PURE__ */ jsxs("div", { className: "col-start-1 row-start-1 col-span-full lg:col-span-9", children: [
            title && /* @__PURE__ */ jsx(
              title_default,
              {
                className: "title-lg mb-2 lg:title-xl text-heritage-red-full",
                level: "h2",
                text: title
              }
            ),
            startDate && /* @__PURE__ */ jsx(
              show_run_label_default,
              {
                className: "body-md mb-6",
                endDate,
                startDate
              }
            ),
            imageMobile && /* @__PURE__ */ jsx(
              sanity_image_default,
              {
                className: [
                  "relative block lg:hidden",
                  "row-start-2 row-span-2 col-start-1 col-span-12",
                  "rounded-sm overflow-hidden pb-4"
                ].join(" "),
                imageClassName: "object-cover w-full",
                sanityImageSourceData: imageMobile
              }
            ),
            description && /* @__PURE__ */ jsxs(
              "div",
              {
                className: [
                  "relative heading-sm mb-4 max-h-24 overflow-scroll",
                  "pb-4 max-h-[5rem] lg:max-w-[78%]"
                ].join(" "),
                children: [
                  /* @__PURE__ */ jsx(richtext_default, { className: "freetext-richtext", text: description }),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: [
                        "absolute bottom-0 left-0 right-0 h-16",
                        "bg-gradient-to-t from-heritage-white-full  to-transparent",
                        "pointer-events-none"
                      ].join(" ")
                    }
                  )
                ]
              }
            )
          ] }),
          image && /* @__PURE__ */ jsx(
            "div",
            {
              className: [
                "relative hidden lg:block",
                "[@media(max-height:600px)_and_(min-aspect-ratio:1440/600)]:hidden",
                "row-start-1 row-span-2 col-start-10 col-span-3",
                "rounded-sm overflow-hidden"
              ].join(" "),
              children: /* @__PURE__ */ jsx(
                sanity_image_default,
                {
                  imageClassName: "object-cover max-h-[464px] w-full max-w-[309px]",
                  sanityImageSourceData: image,
                  height: 309,
                  width: 464
                }
              )
            }
          ),
          !cta?.label && filteredTiles && filteredTiles.length > 0 && /* @__PURE__ */ jsxs(
            "div",
            {
              className: [
                "hidden lg:block col-start-1 col-span-full mb-8 lg:col-span-9",
                "self-end lg:self-center min-[90rem]:!self-end"
              ].join(" "),
              children: [
                /* @__PURE__ */ jsx(label_default, { text: labels?.nextShowTimes, className: "body-lg mb-4" }),
                /* @__PURE__ */ jsx("div", { className: "flex gap-x-2", children: filteredTiles.slice(0, 5).map((tile) => {
                  return /* @__PURE__ */ jsx(
                    date_tile_default,
                    {
                      ...tile,
                      className: `${tile.className} grow-0 shrink-0`
                    },
                    tile.id
                  );
                }) })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: [
                "col-start-1 col-span-full lg:col-span-9",
                "flex flex-col md:flex-row w-[100%] md:w-auto"
              ].join(" "),
              children: [
                cta?.label && /* @__PURE__ */ jsxs(
                  link_default,
                  {
                    "aria-label": cta.label,
                    className: "button-primary",
                    href: cta.destination || "/",
                    tracking: {
                      label: cta.label,
                      layout: "Show Detail"
                    },
                    children: [
                      cta.label,
                      cta.isExternal && /* @__PURE__ */ jsx(
                        icon_default,
                        {
                          name: "arrow-right",
                          className: "ml-2 h-[0.75em]",
                          SVGClassName: "h-[100%] w-auto"
                        }
                      )
                    ]
                  }
                ),
                targetPage && !cta?.label && /* @__PURE__ */ jsxs(
                  link_default,
                  {
                    className: "button-primary w-full md:w-fit",
                    href: targetPage || "#",
                    tracking: {
                      component: "Card Hero",
                      label: labels?.learnMore
                    },
                    children: [
                      labels?.learnMore,
                      /* @__PURE__ */ jsx(
                        icon_default,
                        {
                          name: "arrow-right",
                          className: "ml-2 h-[0.75em]",
                          SVGClassName: "h-[100%] w-auto"
                        }
                      )
                    ]
                  }
                )
              ]
            }
          )
        ] })
      }
    );
  }
);
var hero_default = CardHero;

export {
  hero_default
};
